import {
  JOB_FILTER_QUERY_KEYS,
  JOB_SEARCH_QUERY_PARAM,
  JOBS_FIRST_PAGE,
} from '@/services/jobs/constants';

export function hasIndexBlockingJobSearchParams(paramNames: Iterable<string>) {
  const names = new Set(paramNames);

  return (
    names.has(JOB_SEARCH_QUERY_PARAM) ||
    JOB_FILTER_QUERY_KEYS.some(key => names.has(key))
  );
}

export function getJobSearchCanonicalPath({
  page,
  pathname,
  shouldNoIndex,
}: {
  page: number;
  pathname: string;
  shouldNoIndex: boolean;
}) {
  if (shouldNoIndex || page <= JOBS_FIRST_PAGE) return pathname;

  return `${pathname}?page=${page}`;
}
